// Espelha o enum GiftValueType do pontuax-backend (src/models/giftValueType.ts)
export enum GiftValueType {
  cents = 'cents',
  volume = 'volume',
  /**
   * Quantidade de PONTOS. Usado pela regra `points_exchange`, em que o valor
   * da regra é o PREÇO da troca — não litro nem real. Renderizar como número
   * inteiro seguido de "pontos", nunca com R$ nem L.
   */
  points = 'points',
}
